import VirtusTheme from './VirtusTheme';
export default VirtusTheme;
